import { render, staticRenderFns } from "./registeredSheet.vue?vue&type=template&id=4ba50052&scoped=true"
import script from "./registeredSheet.vue?vue&type=script&lang=js"
export * from "./registeredSheet.vue?vue&type=script&lang=js"
import style0 from "./registeredSheet.vue?vue&type=style&index=0&id=4ba50052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba50052",
  null
  
)

export default component.exports